import { NUMBER } from 'common/constants/gridType';
import { REGULAR_UNIT } from 'components/FeaturedSpreadsheet/constants';
import { ConfigurationCellMap } from 'models/interfaces/spreadsheet-types/core-types';
import { alphabetGenerator } from 'utilities';
import { largeCurrencyFormat, smallCurrencyFormat } from '../../../../../common/formats/formats';
import WaterfallUnscaledHeaderValueViewer from '../../WaterfallUnscaledHeaderValueViewer';
import { WaterfallParserParams, WaterfallSheetColumns } from '../useWaterfallSheetConfig/useWaterfallSheetConfig.types';

const totalClassRight = 'title-col division-bottom-only division-top-only subtitle cell text-right';
const securityRowLabelClass = 'row-label subtitle-indented';
const WaterfallParser = ({ rowConfig, columns }: WaterfallParserParams) => {
  const cells: ConfigurationCellMap<object, object, WaterfallSheetColumns, object> = {};

  const sumCells: string[] = [];
  const alphabet = alphabetGenerator([], columns.length);
  rowConfig.forEach((row, index) => {
    columns.forEach((column, columnIndex) => {
      const columnLegend = alphabet[columnIndex];
      const key = `${columnLegend}${index + 1}`;
      if (index === 0) {
        const { className } = row;
        cells[key] = {
          ...row,
          key,
          columnLegend,
          rowNumber: index + 1,
          value: column.label,
          className: columnIndex === 0 ? `${className} text-left` : className,
          valueViewer: column.keyName === 'presentValue' ? WaterfallUnscaledHeaderValueViewer : undefined,
        };
      } else if (index === rowConfig.length - 1) {
        if (columnIndex === 1) {
          cells[key] = {
            ...row,
            key,
            columnLegend,
            rowNumber: index + 1,
            expr: `=SUM(${sumCells.join(',')})`,
            gridType: NUMBER,
            className: totalClassRight,
            format: largeCurrencyFormat,
          };
        } else if (columnIndex === 0) {
          cells[key] = {
            ...row,
            columnLegend,
            key,
            rowNumber: index + 1,
          };
        } else {
          cells[key] = {
            key,
            columnLegend,
            rowNumber: index + 1,
            value: '',
            className: totalClassRight,
          };
        }
      } else {
        const value = row[column.keyName];
        const getFormat = () => {
          if (columnIndex === 0) {
            return undefined;
          }
          if (columnIndex === 1) {
            sumCells.push(key);
            return largeCurrencyFormat;
          }
          return smallCurrencyFormat;
        };
        cells[key] = {
          ...row,
          key,
          columnLegend,
          rowNumber: index + 1,
          readOnly: true,

          value,
          gridType: NUMBER,
          format: getFormat(),
          customFormat: columnIndex > 1 ? { currency: { units: REGULAR_UNIT } } : undefined,
          className: columnIndex === 0 ? securityRowLabelClass : row.className,
        };
      }
    });
  });
  return cells;
};

export default WaterfallParser;
